import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import PedWorkspaceGuard from '@/components/shared/PedWorkspaceGuard';
import { Button } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';
import { ServiceUploadingOptions } from '@/utils/shared/uploadProgress';

import ResourceInlineForm, { ResourceFormFields } from './ResourceInlineForm';
import { usePedWorkspaceStatus } from '@/data/context/PedWorkspaceContext';

type ResourceFormListProps = {
  onSubmit: (
    data: ResourceFormFields,
    options?: ServiceUploadingOptions,
  ) => Promise<unknown>;
  isLoading?: boolean;
};

export default function ResourceFormList({
  onSubmit,
  isLoading,
}: ResourceFormListProps) {
  const { isLimitedEdition } = usePedWorkspaceStatus();
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.resourcesTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<ResourceFormFields>({ onSubmit });

  return (
    <div className="flex flex-col gap-6 -mt-6">
      {openForms.map(formId => (
        <ResourceInlineForm
          key={formId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
        />
      ))}
      <FieldsetContainer>
        <PedWorkspaceGuard className="w-full">
          <Button
            size="md"
            onClick={addForm}
            className="bg-base-300 w-full"
            disabled={isLimitedEdition}
          >
            <PlusIcon className="w-4 h-4" />
            {t('createResource')}
          </Button>
        </PedWorkspaceGuard>
      </FieldsetContainer>
    </div>
  );
}
